import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface LoaderProps {
  /**
   * Size variant of the loader
   * - 'small': Used for buttons and inline elements (16px)
   * - 'large': Used for page and component loading states (32px)
   */
  size?: 'small' | 'large';
  
  /**
   * Custom CSS class names
   */
  className?: string;
  
  /**
   * Color of the loader (defaults to blue-500)
   */
  color?: string;
}

/**
 * Standardized loading spinner component with consistent sizing across the application
 */
export function Loader({ size = 'large', className, color = 'text-blue-500' }: LoaderProps) {
  // Size values
  const sizeValue = size === 'small' ? 16 : 32;
  
  return (
    <Loader2 
      size={sizeValue} 
      className={cn('animate-spin', color, className)}
    />
  );
}